import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";

export interface BlogBlock1Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  header: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const BlogBlock1 = forwardRef<HTMLDivElement, BlogBlock1Props>(
  ({ header, content, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-flex wb-flex-col wb-gap-12 md:wb-gap-16 wb-max-w-2xl wb-mx-auto">
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-3 md:wb-gap-5">
                  {header}
                </BlockSection.NestedBlock>
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-3 md:wb-gap-5">
                  {content}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

BlogBlock1.displayName = "BlogBlock1";
